module.exports = __webpack_public_path__ + "static/media/Customer-Terms-of-Business-Confused-Jan-2024.9ddf53f7.pdf";